import axios from 'axios';
import { constants } from '@skunexus/utils';

const { API_PATH } = constants.CONFIG;

export async function fetchDictionaries() {
    const query = `query {
        product {
            dictionaries {
                divisions {
                    value
                    label
                }
            }
        }
    }`;

    return axios.post(`${API_PATH}/query`, { query });
}
